import { Button } from '@eventbrite/eds-button';
import React from 'react';
import { INotificationContextItem } from '../../../contexts/NotificationsContext';

const AuthNotificationButton = ({
    notificationMessage,
    handleOnClick,
}: {
    notificationMessage: INotificationContextItem;
    handleOnClick?: () => void;
}) => {
    const { cta } = notificationMessage;
    let buttonComponent = null;

    if (cta?.action) {
        const _handleOnClick = () => {
            notificationMessage?.cta?.action?.();
            handleOnClick?.();
        };

        buttonComponent = (
            <Button onClick={_handleOnClick} type="button" style="anchor">
                {cta.message}
            </Button>
        );
    } else if (cta?.link) {
        buttonComponent = (
            <a href={cta.link} target="_blank" rel="noopener noreferrer">
                {cta.message}
            </a>
        );
    }

    return buttonComponent;
};

export default AuthNotificationButton;
